/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

export interface UpdateIntegrationDto {
  /** Whether the integration should be enabled for this client */
  enabled?: boolean;
  /** New Azure AD application (client) ID, to rotate this connection's credentials */
  appId?: string;
  /** New Azure AD directory (tenant) ID, to rotate this connection's credentials */
  directoryId?: string;
  /** New Azure AD application client secret value, to rotate this connection's credentials */
  secret?: string;
}
